export const enum PlanType {
    Free = 'free',
    Standard = 'standard',
    Pro = 'professional',
}

export const PlanLevel = {
    [PlanType.Free]: 0,
    [PlanType.Standard]: 1,
    [PlanType.Pro]: 2,
}

export const PlanDisplayNameMap = {
    [PlanType.Free]: 'Starter',
    [PlanType.Standard]: 'Pro',
    [PlanType.Pro]: 'Premium',
}
